// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display-field .table-text{word-wrap:break-word;font-size:11px}", ""]);
// Exports
module.exports = exports;
